import React, { useEffect, useState, useRef, useCallback } from 'react'
import { Select } from '../../common/components/select'
import { reportDataSetService } from '../editor/report-data-set.service'
import { useStyles } from './split-chart-filter-bar.style'

export const SplitChartFilterBar = function ({ filterDefinition, onChange = () => {}, className = '' }) {
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const getSplitChartFilterSelections = () => reportDataSetService.getFilterDefinitionSplitChartSelections(filterDefinition)

  const classes = useStyles({ dropdownOpen })
  const currentSelectionsRef = useRef()
  const currentDefaultSelectionsRef = useRef()
  const currentOptionsRef = useRef()
  const splitChartFilter = filterDefinition && filterDefinition.fields && filterDefinition.fields.find(({ isSplitChartFilter }) => isSplitChartFilter)
  const [splitChartSelections, setSplitChartSelections] = useState(getSplitChartFilterSelections())

  const validOptions = splitChartFilter ? splitChartFilter.options.filter(({ hide }) => (!hide)) : []

  function handleFilterChange (valueIndex, value) {
    currentDefaultSelectionsRef.current = splitChartFilter && splitChartFilter.defaultSelections
    if (splitChartSelections) {
      const newSplitChartSelections = {
        key: splitChartFilter.key,
        values: [...currentSelectionsRef.current.values]
      }
      newSplitChartSelections.values[valueIndex] = value
      setSplitChartSelections(newSplitChartSelections)
      currentSelectionsRef.current = newSplitChartSelections
      onChange(newSplitChartSelections)
    }
  }

  useEffect(() => {
    if (splitChartFilter) {
      const currentSplitChartSelections = getSplitChartFilterSelections()
      setSplitChartSelections(currentSplitChartSelections)
      currentSelectionsRef.current = currentSplitChartSelections
      currentDefaultSelectionsRef.current = currentSplitChartSelections
      if (JSON.stringify(currentSplitChartSelections) !== JSON.stringify(splitChartSelections)) {
        onChange(currentSplitChartSelections)
      }
    }
  }, [])

  useEffect(() => {
    // When a new default filter value is selected in the sidebar,
    // update the preview's data to have the new value selected
    const newDefaultSelections = getSplitChartFilterSelections()
    if (JSON.stringify(currentDefaultSelectionsRef.current) !== JSON.stringify(newDefaultSelections.values)) {
      currentDefaultSelectionsRef.current = newDefaultSelections
    } else {
      return
    }

    if (newDefaultSelections) {
      const currentSelections = (currentSelectionsRef.current && currentSelectionsRef.current.values) || []
      for (let i = 0; i < newDefaultSelections.values.length; i++) {
        if (newDefaultSelections.values[i] !== currentSelections[i]) {
          handleFilterChange(i, newDefaultSelections.values[i])
        }
      }
      currentSelectionsRef.current = newDefaultSelections
      currentDefaultSelectionsRef.current = newDefaultSelections.values
    }
  }, [splitChartFilter && splitChartFilter.defaultSelections])

  useEffect(() => {
    if (validOptions.length !== undefined && splitChartSelections && splitChartSelections.values && splitChartSelections.values.length) {
      splitChartSelections.values.forEach((selection, i) => {
        if (!validOptions.find((option) => option.value === selection)) {
          const defaultSelection = splitChartFilter && splitChartFilter.defaultSelections && splitChartFilter.defaultSelections[i]
          if (defaultSelection !== selection) {
            // Revert this selection to the default selection
            handleFilterChange(i, defaultSelection)
          }
        }
      })
    }
    currentOptionsRef.current = validOptions
  }, [validOptions.length])

  const onSelectOpen = useCallback(() => {
    setDropdownOpen(true)
  }, [])

  const onSelectClose = useCallback(() => {
    setDropdownOpen(false)
  }, [])

  return splitChartSelections ? (
    <div className={`${classes.container} ${className}`} data-qa="split-chart-filter-bar">
      <div className="split-chart-filter-bar-element" data-qa="split-chart-filter-bar-element-1">
        <Select
          size="medium"
          width={200}
          className={classes.splitChartSelect}
          label={splitChartFilter.label || 'Filter A'}
          options={validOptions}
          value={splitChartFilter.options.find(({ value }) => value === splitChartSelections.values[0])}
          onChange={({ value }) => handleFilterChange(0, value)}
          onOpen={onSelectOpen}
          onClose={onSelectClose}
        />
      </div>
      <div className="split-chart-filter-bar-element" data-qa="split-chart-filter-bar-element-2">
        <Select
          size="medium"
          width={200}
          className={classes.splitChartSelect}
          label={splitChartFilter.label || 'Filter B'}
          options={validOptions}
          value={splitChartFilter.options.find(({ value }) => value === splitChartSelections.values[1])}
          onChange={({ value }) => handleFilterChange(1, value)}
          onOpen={onSelectOpen}
          onClose={onSelectClose}
        />
      </div>
    </div>
  ) : null
}
